module.exports = __webpack_public_path__ + "static/media/431750376_221401617698087_8331318611389332098_n.39adc092.jpg";